import FullAdCarouselBuilder from './FullAdCarouselBuilder/FullAdCarouselBuilder';

const FullAdCarouselBuilderDirective = (
  reactDirective,
  $modal,
  $rootScope,
  CreativeService
) => {
  return reactDirective(
    FullAdCarouselBuilder,
    undefined,
    {
      restrict: 'E'
    },
    {
      $modal,
      $rootScope,
      CreativeService
    }
  );
};

FullAdCarouselBuilderDirective.$inject = [
  'reactDirective',
  '$modal',
  '$rootScope',
  'CreativeService'
];

export default FullAdCarouselBuilderDirective;
